import React, { useState, useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Modal,
  TextField,
  Typography
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { months, years } from 'constants/months';

const VendorProcessModal = (props) => {

  const [tableData, setTableData] = useState([]);
  const [totalCost, setTotalCost] = useState(0);
  const [userInput, setUserInput] = useState({firstLetter: "", id: "", name: ""});
  
  const [values, setValues] = useState({
    month: "0",
    year: moment().year().toString()
  });

  const usersObj = useMemo(() => (
    props.user.standardUsers
      .map(user => {
        const firstLetter = user.name[0].toUpperCase();
        return {firstLetter, id: user.id, name: user.name}
      })
      .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))

  ), [props.user.standardUsers]);

  const columns = [
    { label: "Process ID", name: "displayId" },
    { label: "Product Name", name: "productName" },
    { label: "Step Type", name: "stepType" },
    { label: "Cost", name: "cost" },
    { label: "Start Date", name: "startDate" }
  ];

  const options = {
    selectableRows: 'none',
    search: false,
    download: false,
    print: false,
    filter: false,
    viewColumns: false
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const searchProcesses = () => {
    const tableDataBuffer = [];
    const startDate = moment([ values.year, values.month ]);
    var totalCostBuffer = 0;

    for ( let i = 0; i < props.processes.length; i++ ) {
      const currProcess = props.processes[i];
      if(currProcess.userId === userInput.id) {
        for ( let j = 0; j < currProcess.steps.length; j++ ) {
          const step = currProcess.steps[j];
          if(step.vendorId === props.vendorId && startDate.isSame(step.createdAt, 'month') && step.completed) {
            const productInfo = props.products.find(product => product.id === currProcess.productId);
            tableDataBuffer.push({
              displayId: currProcess.displayId,
              productName: productInfo ? productInfo.name : "",
              stepType: step.type,
              cost: step.cost,
              startDate: moment(step.createdAt).format('DD/MM/YYYY')
            });
            totalCostBuffer += step.cost;
          }
        }
      }
    }

    setTableData(tableDataBuffer);
    setTotalCost(totalCostBuffer);
    setUserInput({firstLetter: "", id: "", name: ""});
  };

  return (
    <Modal open={props.open}>
      <Card>
        <CardHeader
          subheader="Please select the User and Month."
          title="Vendor Processes"
        />
        <Divider />
        <CardContent>
          <Box>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={4}
                xs={12}
              >
                <Autocomplete
                  onChange={(event, newValue) => {
                    if(newValue) setUserInput(newValue);
                    else setUserInput({firstLetter: "", id: "", name: ""});
                  }}
                  id="free-solo-dialog-demo"
                  fullWidth
                  options={usersObj}
                  groupBy={(user) => user.firstLetter}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User.."
                      variant="outlined"
                    />
                  )}
                  value={userInput ? ( userInput.id ? userInput : null ) : null}
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Select Month"
                  name="month"
                  onChange={handleChange}
                  select
                  SelectProps={{ native: true }}
                  value={values.month}
                  variant="outlined"
                >
                  {months.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <Box
                  display="flex"
                  alignItems="center"
                >
                  <TextField
                    style={{ flexShrink: 1 }}
                    fullWidth
                    label="Select Year"
                    name="year"
                    onChange={handleChange}
                    select
                    SelectProps={{ native: true }}
                    value={values.year}
                    variant="outlined"
                  >
                    {years.map((option) => (
                      <option
                        key={option}
                        value={option}
                      >
                        {option}
                      </option>
                    ))}
                  </TextField>
                  <Button
                    style={{ flexShrink: 0, width: 120, marginLeft: 32, marginRight: 48 }}
                    disabled={!userInput.id}
                    variant="contained"
                    color="primary"
                    onClick={searchProcesses}
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1%',
                marginBottom: '1%'
              }}
            >
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                Total Cost : {totalCost} AED
              </Typography>
            </Box>
            <Box
              sx={{
                overflow: 'auto',
                height: 387
              }}
            >
              <MUIDataTable
                data={tableData}
                columns={columns}
                options={options}
              />
            </Box>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1%'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={props.closeModal}
              >
                Close
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default VendorProcessModal;